import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public setSessionItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public getSessionItem(key: string): string {
    return sessionStorage.getItem(key);
  }

  public removeSessionItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  public clearSession(): void {
    sessionStorage.clear();
  }

  public setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public getItem(key: string): string {
    return localStorage.getItem(key);
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }
}
